import React from "react";
import { Box } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { resultColumns } from "./columnsData/columns";
import { useFieldArray, useFormContext } from "react-hook-form";
import {
  useResponsiveShellTable,
  getResponsiveShellTableConfig,
} from "./responsiveShellTable";

// Edge Mentor code labels for the Shell Result table (DataGridView6).
// These semantic labels match the Edge Mentor Excel/content inventory.
const SHELL_RESULT_EDGE_MENTOR_CODE_LABELS = {
  Allowable_Stress: "shellResultAllowableStress",
  Required_Thickness: "shellResultRequiredThickness",
  UCS_Curve: "shellResultUcsCurve",
  MDMT: "shellResultShellResultMdmt",
  MAWP: "shellResultShellResultMawp",
  Hydrotest_Pressure: "shellResultShellHydrotestPressure",
};

const SHELL_RESULT_COLUMN_WEIGHTS = {
  Allowable_Stress: 1.2,
  Required_Thickness: 1,
  UCS_Curve: 0.9,
  MDMT: 0.85,
  MAWP: 0.9,
  Hydrotest_Pressure: 1.15,
};

const ResultTable = (props) => {
  const { isLoading } = props;
  const { control } = useFormContext();
  const { fields: resultFields } = useFieldArray({
    control,
    name: "DataGridView6",
  });

  const { viewportRef, tableWidth, headerFontSize, bodyFontSize, columns } =
    useResponsiveShellTable(resultColumns, SHELL_RESULT_COLUMN_WEIGHTS);

  const { mrtProps, headCellSx, bodyCellSx } = getResponsiveShellTableConfig({
    tableWidth,
    headerFontSize,
    bodyFontSize,
  });

  return (
    <Box
      ref={viewportRef}
      sx={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        overflowX: "hidden",
      }}
    >
      <MaterialReactTable
        {...mrtProps}
        columns={columns}
        data={resultFields ?? []}
        enableSorting={false}
        enableColumnActions={false}
        state={{
          isLoading,
        }}
        muiTableHeadCellProps={{
          sx: headCellSx,
        }}
        muiTableBodyCellProps={({ cell }) => ({
          "data-edge-mentor":
            SHELL_RESULT_EDGE_MENTOR_CODE_LABELS[cell.column.id] || undefined,

          sx: bodyCellSx,
        })}
      />
    </Box>
  );
};

export default ResultTable;
